/*
 * @Description: 计算字段api
 * @Version: 2.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 */

import { BaseService } from './base-service';
class FormulaFieldService extends BaseService {
  /**
   * @description: 计算字段-函数类查询
   * @param {*} data
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */
  getFieldFunctions(data) {
    return this.request({
      method: 'get',
      url: `/clue_setting/field/getFunctions`,
      params: data
    });
  }
  /**
   * @description: 计算字段-公式校验
   * @param {*} data
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */
  checkFormula(data) {
    return this.request({
      method: 'post',
      url: `/compute/checkFormula`,
      params: { apiIndex: `${data.entityId}-${Math.random() * 100}` },
      data
    });
  }
  /**
   * @description: 查询参与计算的字段
   * @param {*} data
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */
  findComputing(data) {
    return this.request({
      method: 'post',
      url: `/compute/findComputing`,
      data
    });
  }
  /**
   * @description: 计算字段计算结果
   * @param {*} data
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */
  getCalculationResults(data) {
    return this.request({
      method: 'post',
      url: `/compute/computing`,
      params: { apiIndex: `${data.entity}-${Math.random() * 100}` },
      data
    });
  }

  /**
   * @description: 计算字段数据校准
   * @param {*} data
   * @return {*}
   * @author: sj
   */
  calculationCalibration(data) {
    return this.request({
      method: 'post',
      url: `/compute/recompute`,
      data
    });
  }
  // 计算字段公式内包含的字段
  getComputeSettings(data) {
    return this.request({
      method: 'get',
      url: `/compute/settings/computerRelationInfo`,
      params: data
    });
  }
  // 查询对象集合下字段信息
  getEntitySettings(data) {
    return this.request({
      method: 'post',
      url: `/entity/settings/info`,
      params: { apiIndex: `${data?.entities?.[0]}-${Math.random() * 100}` },
      data
    });
  }
}

export const formulaFieldService = new FormulaFieldService();
